import { isEmpty, isNil } from 'lodash-es';
import React from 'react';

type DisplayValueProps<TValue> = {
  value: TValue;
  renderer?: (value: NonNullable<TValue>) => React.ReactNode;
  fallbackRenderer?: (value: TValue) => React.ReactNode;
};
export function DisplayValue<TValue>({
  value,
  renderer = value => <>{value}</>, // TODO: this should not allow undefined
  fallbackRenderer = _ => <>&mdash;</>
}: DisplayValueProps<TValue>) {
  const isNilOrEmpty = isNil(value) || (typeof value === 'string' && isEmpty(value));

  return isNilOrEmpty ? fallbackRenderer(value) : renderer(value!);
}
